<template>
<div>
  <data-table :columns="columns" :rows="rows" :current-page="currentPage" :has-pagination="false" @onSearch="searchFn">
    <template v-slot:actions="slotProps">
      <div v-if="slotProps.row.productId">
        <div class="button-items" v-if="slotProps.row.productId.shipmentsPaginated.objects.length > 0">
          <b-button v-if="adjust_stock_permission" v-b-modal.adjust-stock variant="primary" size="sm" class="py-1 text-white" @click="selectStock(slotProps.row)">
            Adjust Stock
          </b-button>
          <b-button v-if="move_stock_permission" v-b-modal.move-stock variant="danger" size="sm" class="py-1 text-white" @click="selectStock(slotProps.row)">
            Move Stock
          </b-button>
        </div>
      </div>
    </template>
  </data-table>
  <b-modal
      id="adjust-stock"
      centered
      hide-footer
      hide-header
      title-class="font-18">
    <div class="p-2">
      <h3>Adjust Stock</h3>
      <adjust-stock-modal :stockInfo="selected_stock" @adjustStock="adjustStock"/>
      <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('adjust-stock')">Close</b-button>
    </div>
  </b-modal>
  <b-modal
      id="move-stock"
      size="lg"
      centered
      hide-footer
      hide-header
      title-class="font-18">
    <div class="p-2">
      <h3>Move Stock</h3>
      <move-stock-modal @moveStock="moveStock" :stockInfo="selected_stock" :warehouses="warehouses"/>
      <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('move-stock')">Close</b-button>
    </div>
  </b-modal>
</div>
</template>

<script>
import AdjustStockModal from "@/components/stock/adjust-stock-modal";
import MoveStockModal from "@/components/stock/move-stock-modal";
import DataTable from "@/components/data-table";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import {routeItems} from "@/router/endpoints";
import {ALL_WAREHOUSES} from "@/gql";
import {permissions} from "@/router/permissions";

export default {
  name: "stock-table",
  components: {DataTable, MoveStockModal, AdjustStockModal},
  data(){
    return{
      selected_stock: '',
      move_stock_permission: permissions.move_stock_permission,
      adjust_stock_permission: permissions.adjust_stock_permission,
      warehouses: {
        objects: []
      }
    }
  },
  props: {
    rows: {type: Array},
    columns: {type: Array},
    currentPage: {type: Number, default: 1}
  },
  apollo: {
    warehouses: {
      query: ALL_WAREHOUSES,
      variables(){
        return {
          page: 1,
          perPage: 30,
          isActive: true,
        }
      }
    }
  },
  methods:{
    ... mapActions({
      adjustStockfn: 'stock/adjustStock',
      moveStockFn: 'stock/moveStock'
    }),
    selectStock(row){
      this.selected_stock = {
        productId: row.productId.publicId,
        productName: row.productId.productName,
        shipments: row.productId.shipmentsPaginated.objects,
        warehouseId: row.warehouseId.publicId,
        warehouseName: row.warehouseId.name,
        shipmentId: '',
        quantity: '',
        dateOrdered: '',
        description: ''
      }
    },
    async adjustStock(data){
      await this.adjustStockfn(data).then(resp => {
        if(resp.publicId){
          this.$emit('updateStockInfo')
          successToast(`Stock adjusted successfully`)
          this.$router.push(routeItems.adjusted_stock_route)
        }
      })
    },
    async moveStock(data){
      await this.moveStockFn(data).then(resp => {
        if(resp.message){
          this.$emit('updateStockInfo')
          successToast(`${resp.message}`)
        }
      })
    },
    searchFn(data){
      this.$emit('onSearch', data)
    }
  }
}
</script>

<style scoped>

</style>
